import { render, staticRenderFns } from "./liveClassToBeReviewed.vue?vue&type=template&id=122754ec"
import script from "./liveClassToBeReviewed.vue?vue&type=script&lang=js"
export * from "./liveClassToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./liveClassToBeReviewed.vue?vue&type=style&index=0&id=122754ec&prod&lang=less&scope=true"
import style1 from "./liveClassToBeReviewed.vue?vue&type=style&index=1&id=122754ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports